import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { BaseService } from './base.service';
import { DataGroup, DataGroupColumn, PatientDatum } from '../models/data-group.model';
import { Tag } from '../models/tag.model';
import * as _ from 'underscore';
import { DataType } from '../models/data-type.model';
import { Download } from '../models/download.model';

@Injectable()
export class DownloadService extends BaseService {

  constructor(protected http: Http) {
    super(http);
  }

  async requestBatchDownload(dataItems: Array<any>, formattedItemsForSpreadsheet: Array<any>,
    isFromApprovalPage?: boolean, emailDownloadLink?: boolean): Promise<Download> {
    return this.post('download', {dataItems: dataItems, formattedItemsForSpreadsheet: formattedItemsForSpreadsheet,
      isFromApprovalPage: isFromApprovalPage, emailDownloadLink: emailDownloadLink});
  }

  async getDownloadStatus(download: Download): Promise<Download> {
    return this.get('download/status/' + download.downloadId);
  }

  async getDownloadLink(download: Download): Promise<any> {
    return this.get('download/link/' + download.downloadId);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/download.service.ts